module.exports = __webpack_public_path__ + "static/media/2-4.e32bd44c.mp3";